<div class="pr-1 req-access-heading" [hidden]="userPeId === ''">
  {{ 'broker.compensation.requestaccess.requestStmtTitle' | translate }}
</div>
<div class="pr-1 req-access-heading" [hidden]="userPeId !== ''">
  {{ 'broker.compensation.requestaccess.noPeidHeaderTitle' | translate }}
</div>
<div class="pt-1 req-access-info" [hidden]="userPeId === ''">
  {{ 'broker.compensation.requestaccess.compReqestAccessText' | translate }}
  <br />
  <br />
  <span>{{
    'broker.compensation.requestaccess.reqAccessIfYouNeedAssistance' | translate
  }}</span>
  <a
    [hidden]="isImpersonatorFlag"
    (click)="navigateContactUs()"
    class="msg-high-color"
    >{{ 'global.contactUs' | translate | lowercase }}.</a
  >
  <span [hidden]="!isImpersonatorFlag">
    <span class="impersonator-disabled">{{
      'global.contactUs' | translate | lowercase
    }}</span
    >.
  </span>
</div>

<div class="no-peid-txt" [hidden]="userPeId !== ''">
  <span>{{ 'broker.compensation.manage.noPeidTxt1' | translate }}</span>
  <a
    data-test-id="request-statement-access-link"
    class="no-peid-txt-link"
    *ngIf="!isImpersonatorFlag"
    (click)="navigateContactUs()"
    [hidden]="isImpersonatorFlag"
    >{{ 'broker.compensation.manage.noPeidTxt2' | translate }}</a
  >
  <span
    data-test-id="request-statement-access-link"
    class="no-peid-txt-link-disabled"
    *ngIf="isImpersonatorFlag"
    [hidden]="!isImpersonatorFlag"
    >{{ 'broker.compensation.manage.noPeidTxt2' | translate }}</span
  >
  <span>
    {{ 'broker.compensation.manage.noPeidTxt3' | translate }}
  </span>
</div>
